<template>
  <div
    class="t-course-list"
    :class="{
      'electron-t-course-list': isElectron,
      'h5-t-course-list': isH5,
    }"
  >
    <div class="teacher-course-toolbar">
      <CourseSearchInput
        v-model="keyword"
        :loading="searchSubmitting"
        :search-disabled="!canSubmitSearch"
        :size="isH5 ? 'h5' : 'default'"
        @search="handleSearch"
        @clear="handleClearSearch"
      />
    </div>
    <ul
      v-if="courseList.length"
      v-loading="resultLoading"
      class="course-list-wrap"
    >
      <li
        class="my-course-crad"
        @click="showDetail(item.course_id)"
        v-for="item in courseList"
        :key="item.course_id"
      >
        <div class="cover">
          <img :src="processImageUrl(item.cover_url, 600)" alt="" />
        </div>
        <div class="course-info">
          <p class="name">
            {{ item.course_name }}
          </p>
          <p class="lesson-num">
            课时数：<span>{{ item.lesson_count }}课时</span>
          </p>
        </div>
      </li>
    </ul>
    <el-empty
      v-else
      v-loading="resultLoading"
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import moment from "moment";
import { getMyCourseList } from "@saas/service-api/src/teacher";
import { isH5, processImageUrl } from "@saas/components";
import CourseSearchInput from "../../learning-center/my-course/components/CourseSearchInput.vue";
import {
  buildCourseListParams,
  canSubmitCourseSearch,
  createDelayedLoadingController,
  normalizeCourseKeyword,
} from "../../learning-center/my-course/course-list-search";
export default {
  data: function () {
    return {
      moment,
      courseList: [],
      keyword: "",
      activeKeyword: "",
      page_no: 1,
      page_size: 18,
      noMore: false, //没有更多
      loading: false, //加载数据中
      resultLoading: false,
      searchSubmitting: false,
      resultLoadingController: null,
      courseListRequestId: 0,
      isElectron: window.isElectron,
      isH5: isH5(),
    };
  },
  created() {
    this.resultLoadingController = createDelayedLoadingController({
      setLoading: (value) => {
        this.resultLoading = value;
      },
    });
    this.apiGetCourseList();
  },
  mounted() {
    this.$nextTick(() => {
      if (window.isElectron) {
        let elMain = document.getElementById("electron-main");
        if (!elMain) return;
        elMain.addEventListener("scroll", this.handleElScrollFn, true);
      } else {
        window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
      }
    });
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
    if (this.resultLoadingController) {
      this.resultLoadingController.cancel();
    }
  },
  components: {
    CourseSearchInput,
  },
  computed: {
    canSubmitSearch() {
      return canSubmitCourseSearch({
        keyword: this.keyword,
        activeKeyword: this.activeKeyword,
      });
    },
  },
  methods: {
    processImageUrl,
    apiGetCourseList() {
      const requestId = ++this.courseListRequestId;
      const shouldShowResultLoading = this.page_no === 1;
      this.loading = true;
      if (shouldShowResultLoading) {
        this.resultLoadingController.start();
      }
      let params = buildCourseListParams({
        page_no: this.page_no,
        page_size: this.page_size,
        keyword: this.activeKeyword,
      });
      return getMyCourseList(params)
        .then((res) => {
          if (requestId !== this.courseListRequestId) return;
          if (res.code === 1) {
            let arr = res.data?.list || [];
            if (params.page_no === 1) {
              this.courseList = arr;
            } else {
              this.courseList = this.courseList.concat(arr);
            }
            if (this.courseList.length === res.data.total) {
              this.noMore = true;
            } else {
              this.noMore = false;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          if (requestId !== this.courseListRequestId) return;
          this.$message.error(err?.message || "加载失败");
        })
        .finally(() => {
          if (requestId !== this.courseListRequestId) return;
          this.loading = false;
          if (shouldShowResultLoading) {
            this.resultLoadingController.stop();
          }
        });
    },
    handleSearch() {
      if (this.searchSubmitting || !this.canSubmitSearch) return;
      this.activeKeyword = normalizeCourseKeyword(this.keyword);
      this.page_no = 1;
      this.noMore = false;
      this.searchSubmitting = true;
      this.apiGetCourseList().finally(() => {
        this.searchSubmitting = false;
      });
    },
    handleClearSearch() {
      if (this.searchSubmitting) return;
      if (!this.activeKeyword) return;
      this.activeKeyword = "";
      this.page_no = 1;
      this.noMore = false;
      this.searchSubmitting = true;
      this.apiGetCourseList().finally(() => {
        this.searchSubmitting = false;
      });
    },
    handleElScrollFn(event) {
      if (this.loading || this.noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.loading = true;
          this.page_no++;
          this.apiGetCourseList();
        } else {
          window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
        }
      }
    },
    showDetail(id) {
      this.$router.push({ name: "TCourseDetail", params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.t-course-list {
  min-height: calc(100vh - 110px);
  .teacher-course-toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    --course-search-width: 280px;
  }
  .course-list-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .my-course-crad {
    margin: 0 30px 30px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    &:hover {
      transition: all 0.3s ease;
      transform: translateY(-5px);
      box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
      .cover img {
        transform: scale(1.2) rotate(0.02deg);
      }
    }
    transition: all 0.3s ease;
    width: 330px;
    height: 296px;
    background: var(--card-bg, #ffffff);
    border: 1px solid var(--border-subtle, transparent);
    border-radius: 24px;
    cursor: pointer;
    padding: 16px;
    display: flex;
    flex-direction: column;
    .cover {
      width: 298px;
      height: 168px;
      border-radius: 16px;
      margin-bottom: 14px;
      overflow: hidden;
    }
    .cover img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: 0.3s ease-in-out;
      will-change: transform;
      transform: scale(1) rotate(0.02deg);
    }
    .course-info {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-weight: 500;
        font-size: 18px;
        color: var(--text-primary, #{$saas-text-color});
        line-height: 28px;
        word-break: break-all;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .lesson-num {
        font-weight: 400;
        font-size: 14px;
        color: var(--text-secondary, #747573);
        line-height: 20px;
      }
    }
  }
  .el-empty {
    height: 400px;
    background: var(--card-bg, #fff);
    color: var(--text-primary, #{$saas-text-color});
    border-radius: 24px;
  }
}

// 客户端
.t-course-list.electron-t-course-list {
  .teacher-course-toolbar {
    margin-bottom: 15px;
    --course-search-width: 220px;
    --course-search-height: 34px;
    --course-search-inner-height: 32px;
    --course-search-btn-height: 30px;
  }
  .my-course-crad {
    margin: 0 15px 15px 0;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    width: 260px;
    height: 240px;
    border-radius: 18px;
    padding: 10px;
    .cover {
      width: 240px;
      height: 135px;
      border-radius: 16px;
      margin-bottom: 12px;
    }
    .course-info {
      .name {
        font-size: 14px;
        line-height: 20px;
      }
      .lesson-num {
        margin-bottom: 6px;
        .white-btn {
          height: 22px;
          line-height: 1;
          border-radius: 10px;
          font-size: 12px;
        }
      }
      .lesson-num,
      .time {
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}

// h5
.t-course-list.h5-t-course-list {
  min-height: calc(100vh - 1.39rem);
  padding-top: 1.39rem;
  background: var(--page-bg);
  .teacher-course-toolbar {
    width: 9.36rem;
    margin: 0 auto 0.32rem;
  }
  .course-list-wrap {
    display: block;
  }
  .my-course-crad {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 9.36rem;
    height: 2.61rem;
    background: var(--card-bg);
    border-color: var(--user-btn-border);
    border-radius: 0.32rem;
    margin: 0 auto 0.32rem;
    padding: 0 0.27rem;
    &:nth-child(3n),
    &:nth-child(4n) {
      margin-right: auto;
    }
    &:hover {
      transform: none;
      box-shadow: none;
    }
    .cover {
      width: 3.2rem;
      height: 2.08rem;
      border-radius: 0.16rem;
      margin: 0 0.27rem 0 0;
      flex-shrink: 0;
    }
    .course-info {
      height: 2.08rem;
      flex: 1;
      width: 0;
      .name {
        font-size: 0.37rem;
        line-height: 0.53rem;
        line-break: anywhere;
      }
      .lesson-num {
        font-size: 0.32rem;
        line-height: 0.45rem;
      }
    }
  }
  .el-empty {
    width: 9.36rem;
    margin: 0 auto;
    background: var(--card-bg);
  }
}
</style>
